import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step6', 'Steps', {
	data() {
		return {
			activeElement: 0,
			step6: null,
			showStep: false,
		};
	},
	props: ['openingDoorSystem'],
	created() {
		this.getDataStep();
	},
	watch: {
		activeElement: function (val) {
			if (this.step6 !== null) {
				this.setPropPosition({ sidelines: this.step6.sidelines[val] });
			}
		},
		openingDoorSystem(val, oldValue) {
			if (val !== undefined && oldValue !== undefined) {
				if (Number(val.id) !== Number(oldValue.id)) {
					if (this.step6 === null) {
						this.setPropPosition({ sidelines: 1 });
					} else {
						this.activeElement = 0;
						this.setPropPosition({ sidelines: this.step6.sidelines[this.activeElement] });
					}
				}
			}
		},
	},
	methods: {
		isDataStep: function () {
			return this.step6.sidelines;
		},
		getDataStep: function () {
			let context = this;
		let store =  { ...this.$store.state.position }
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep6', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					if (!response.data.result.sidelines.length) {
						context.showStep = false;
						context.setPropPosition({ sidelines: 1 });
					} else {
						context.step6 = response.data.result;
						context.showStep = true;
						context.setPropPosition({ sidelines: context.step6.sidelines[context.activeElement] });
					}
				}
			});
		},
	},
	template: `

  <div class="config-block" v-if="showStep">
    <div class="config-block__wrap">
      <div class="config-block__wrap-title">Сторонность</div>
      <Swiper :basicSlidesPerView="1.6" :basicSpaceBetween="20" :breakpointsForSlides="4">
        <div class="swiper-slide" v-for="(slide, index) of step6.sidelines">
          <SimpleItemTop
              :image="slide.image"
              :title="slide.title"
              :price="slide.price"
              :priceType="2"
              :key="index"
              :class="{active: activeElement === index}"
              v-on:setActive="activeElement = index"
          />
        </div>
      </Swiper>
    </div>
    <div v-else>
      <div class="config-block__wrap-title">Сторонность</div>
      <Swiper :basicSlidesPerView="1.6" :basicSpaceBetween="20" :breakpointsForSlides="4">
        <div class="swiper-slide" v-for="i of [1,2,3,4]">
          <PuSkeleton height="220px" />
        </div>
      </Swiper>
    </div>
  </div>
`,
});
